export const classes = {
  tab: 'p-4 h-full',
  list: 'w-full py-0',
  toggle: 'mr-4',
  toggleOption: 'py-1',
};
